// Plan 08-03 — cooldown countdown formatter for accounts list. Picks the
// most useful unit relative to "now" via Intl.RelativeTimeFormat('ru'),
// snapping at minute / hour / day boundaries. Past timestamps render as
// negative («−5 мин назад»); the column hides them by gating on the
// account status before calling.

const rtf = new Intl.RelativeTimeFormat('ru', { numeric: 'auto' });

const SECOND_MS = 1_000;
const MINUTE_MS = 60 * SECOND_MS;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export const formatCooldownCountdown = (iso: string, now: number = Date.now()): string => {
  const target = Date.parse(iso);
  if (Number.isNaN(target)) return '—';
  const diffMs = target - now;
  const absMs = Math.abs(diffMs);
  if (absMs < MINUTE_MS) {
    return rtf.format(Math.round(diffMs / SECOND_MS), 'second');
  }
  if (absMs < HOUR_MS) {
    return rtf.format(Math.round(diffMs / MINUTE_MS), 'minute');
  }
  if (absMs < DAY_MS) {
    return rtf.format(Math.round(diffMs / HOUR_MS), 'hour');
  }
  return rtf.format(Math.round(diffMs / DAY_MS), 'day');
};
